.drop-file-overlay {
  height: 100%;
}

.files-container {
  position: relative;
  padding: 1.6rem;
}

.content {
  color: white;
  font-size: 1.6rem;
  text-align: center;
}

.drop-zone {
  display: flex;
  flex-direction: column;
  gap: 2.4rem;
  position: absolute;
  bottom: 9.6rem;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  left: 0;
  right: 0;
  width: fit-content;
}
